import matchesConstants from "../_constants/matchesConstants";
import matchesService from "../_services/matchesService";
import { forEach } from "lodash";
/* ---------------------------------------------------
  RECENTLY VIEWED MEMBERS
----------------------------------------------------- */

export const recentlyViewedMembers = payload => dispatch => {
  matchesService
    .getRecentlyViewed()
    .then(response => {
      const { results, lastResult } = response;
      dispatch(recentlyViewedMembersSuccess(results));
      if (results.length < 10) {
        dispatch(changeLastResultForMatches(null));
      } else {
        dispatch(changeLastResultForMatches(lastResult));
      }
    })
    .catch(err => {
      dispatch(recentlyViewedMembersSuccess([]));
      dispatch(changeLastResultForMatches(null));
      console.log(err);
    });
};
/* ---------------------------------------------------
 RECENTLY VIEWED MEMBERS SUCCESS
----------------------------------------------------- */
const recentlyViewedMembersSuccess = payload => ({
  type: matchesConstants.RECENTLY_VIEWED_MEMBERS,
  payload
});
/* ---------------------------------------------------
  CLEAR RECENTLY VIEWED MEMBERS
----------------------------------------------------- */
export const clearRecentlyViewedMembers = payload => ({
  type: matchesConstants.CLEAR_RECENTLY_VIEWED_MEMBERS,
  payload
});

/* ---------------------------------------------------
  GET MATCHED MEMBER PROFILE
----------------------------------------------------- */

export const getMatchedMemberProfile = payload => dispatch => {
  matchesService
    .getMemberProfile(payload)
    .then(results => {
      dispatch(getMatchedMemberProfileSuccess(results));
    })
    .catch(err => {
      console.log(err);
    });
};
/* ---------------------------------------------------
 GET MATCHED MEMBER PROFILE SUCCESS
----------------------------------------------------- */
const getMatchedMemberProfileSuccess = payload => ({
  type: matchesConstants.GET_MATCHED_MEMBER_PROFILE,
  payload
});

/* ---------------------------------------------------
 CLEAR MATCHED MEMBERS
----------------------------------------------------- */
export const clearMatchedMembers = payload => ({
  type: matchesConstants.CLEAR_MATCHED_MEMBERS,
  payload
});

/* ---------------------------------------------------
  GET LIKED MEMBERS 
----------------------------------------------------- */

export const getLikedMembers = payload => dispatch => {
  matchesService
    .getLiked()
    .then(response => {
      const { results, lastResult } = response;
      dispatch(getLikedMembersSuccess(results));
      if (results.length < 10) {
        dispatch(changeLastResultForMatches(null));
      } else {
        dispatch(changeLastResultForMatches(lastResult));
      }
    })
    .catch(err => {
      dispatch(getLikedMembersSuccess([]));
      dispatch(changeLastResultForMatches(null));
      console.log(err);
    });
};
/* ---------------------------------------------------
GET LIKED MEMBERS SUCCESS
----------------------------------------------------- */
const getLikedMembersSuccess = payload => ({
  type: matchesConstants.GET_LIKED_MEMBERS,
  payload
});

/* ---------------------------------------------------
CLEAR LIKED MEMBERS
----------------------------------------------------- */
export const clearLikedMembers = payload => ({
  type: matchesConstants.CLEAR_LIKED_MEMBERS,
  payload
});

/* ---------------------------------------------------
  GET SAVED MEMBERS 
----------------------------------------------------- */

export const getSavedMembers = payload => dispatch => {
  matchesService
    .getSaved()
    .then(response => {
      const { results, lastResult } = response;
      dispatch(getSavedMembersSuccess(results));
      if (results.length < 10) {
        dispatch(changeLastResultForMatches(null));
      } else {
        dispatch(changeLastResultForMatches(lastResult));
      }
    })
    .catch(err => {
      dispatch(getSavedMembersSuccess([]));
      dispatch(changeLastResultForMatches(null));
      console.log(err);
    });
};
/* ---------------------------------------------------
GET SAVED MEMBERS SUCCESS
----------------------------------------------------- */
const getSavedMembersSuccess = payload => ({
  type: matchesConstants.GET_SAVED_MEMBERS,
  payload
});

/* ---------------------------------------------------
CLEAR SAVED MEMBERS
----------------------------------------------------- */
export const clearSavedMembers = payload => ({
  type: matchesConstants.CLEAR_SAVED_MEMBERS,
  payload
});

/* ---------------------------------------------------
  GET SHORTLISTED MEMBERS 
----------------------------------------------------- */

export const getShortlistedMembers = payload => dispatch => {
  matchesService
    .getShortlisted()
    .then(response => {
      const { results, lastResult } = response;
      dispatch(getShortlistedMembersSuccess(results));
      if (results.length < 10) {
        dispatch(changeLastResultForMatches(null));
      } else {
        dispatch(changeLastResultForMatches(lastResult));
      }
    })
    .catch(err => {
      dispatch(getShortlistedMembersSuccess([]));
      dispatch(changeLastResultForMatches(null));
      console.log(err);
    });
};
/* ---------------------------------------------------
GET SHORTLISTED MEMBERS SUCCESS
----------------------------------------------------- */
const getShortlistedMembersSuccess = payload => ({
  type: matchesConstants.GET_SHORTLISTED_MEMBERS,
  payload
});

/* ---------------------------------------------------
CLEAR SHORTLISTED MEMBERS
----------------------------------------------------- */
export const clearShortlistedMembers = payload => ({
  type: matchesConstants.CLEAR_SHORTLISTED_MEMBERS,
  payload
});

/* ---------------------------------------------------
  GET EXPRESSED INTEREST MEMBERS 
----------------------------------------------------- */

export const getExpressedInterestMembers = payload => dispatch => {
  matchesService
    .getExpressedInterest()
    .then(response => {
      const { results, lastResult } = response;
      dispatch(getExpressedInterestMembersSuccess(results));
      if (results.length < 10) {
        dispatch(changeLastResultForMatches(null));
      } else {
        dispatch(changeLastResultForMatches(lastResult));
      }
    })
    .catch(err => {
      dispatch(getExpressedInterestMembersSuccess([]));
      dispatch(changeLastResultForMatches(null));
      console.log(err);
    });
};
/* ---------------------------------------------------
GET EXPRESSED INTEREST MEMBERS SUCCESS
----------------------------------------------------- */
const getExpressedInterestMembersSuccess = payload => ({
  type: matchesConstants.GET_EXPRESSED_INTEREST_MEMBERS,
  payload
});

/* ---------------------------------------------------
CLEAR EXPRESSED INTEREST MEMBERS
----------------------------------------------------- */
export const clearExpressedInterestMembers = payload => ({
  type: matchesConstants.CLEAR_EXPRESSED_INTEREST_MEMBERS,
  payload
});

/* ---------------------------------------------------
  GET FAVORITE MEMBERS 
----------------------------------------------------- */

export const getFavoriteMembers = payload => dispatch => {
  matchesService
    .getFavorite()
    .then(response => {
      const { results, lastResult } = response;
      dispatch(getFavoriteMembersSuccess(results));
      if (results.length < 10) {
        dispatch(changeLastResultForMatches(null));
      } else {
        dispatch(changeLastResultForMatches(lastResult));
      }
    })
    .catch(err => {
      dispatch(getFavoriteMembersSuccess([]));
      dispatch(changeLastResultForMatches(null));
      console.log(err);
    });
};
/* ---------------------------------------------------
GET FAVORITE MEMBERS SUCCESS
----------------------------------------------------- */
const getFavoriteMembersSuccess = payload => ({
  type: matchesConstants.GET_FAVORITE_MEMBERS,
  payload
});

/* ---------------------------------------------------
CLEAR FAVORITE MEMBERS
----------------------------------------------------- */
export const clearFavoriteMembers = payload => ({
  type: matchesConstants.CLEAR_FAVORITE_MEMBERS,
  payload
});

/* ---------------------------------------------------
  GET PROFILE VISITORS 
----------------------------------------------------- */

export const getProfileVisitors = payload => dispatch => {
  matchesService
    .getProfileVisitors()
    .then(response => {
      const { results, lastResult } = response;
      dispatch(getProfileVisitorsSuccess(results));
      if (results.length < 10) {
        dispatch(changeLastResultForMatches(null));
      } else {
        dispatch(changeLastResultForMatches(lastResult));
      }
    })
    .catch(err => {
      dispatch(getProfileVisitorsSuccess([]));
      dispatch(changeLastResultForMatches(null));
      console.log(err);
    });
};
/* ---------------------------------------------------
GET PROFILE VISITORS SUCCESS
----------------------------------------------------- */
const getProfileVisitorsSuccess = payload => ({
  type: matchesConstants.GET_PROFILE_VISITORS,
  payload
});

/* ---------------------------------------------------
CLEAR PROFILE VISITORS
----------------------------------------------------- */
export const clearProfileVisitors = payload => ({
  type: matchesConstants.CLEAR_PROFILE_VISITORS,
  payload
});

/* ---------------------------------------------------
  GET PENDING INVITATION 
----------------------------------------------------- */

export const getPendingInvitations = payload => dispatch => {
  matchesService
    .getPendingInvitations()
    .then(response => {
      const { results, lastResult } = response;
      dispatch(getPendingInvitationsSuccess(results));
      if (results.length < 10) {
        dispatch(changeLastResultForMatches(null));
      } else {
        dispatch(changeLastResultForMatches(lastResult));
      }
    })
    .catch(err => {
      dispatch(getPendingInvitationsSuccess([]));
      dispatch(changeLastResultForMatches(null));
      console.log(err);
    });
};
/* ---------------------------------------------------
GET PENDING INVITATION SUCCESS
----------------------------------------------------- */
const getPendingInvitationsSuccess = payload => ({
  type: matchesConstants.GET_PENDING_INVITATIONS,
  payload
});

/* ---------------------------------------------------
CLEAR PENDING INVITATION
----------------------------------------------------- */
export const clearPendingInvitations = payload => ({
  type: matchesConstants.CLEAR_PENDING_INVITATIONS,
  payload
});

/* ---------------------------------------------------
  GET ACCEPT INVITATION 
----------------------------------------------------- */

export const getAcceptInvitations = payload => dispatch => {
  matchesService
    .getAcceptInvitations()
    .then(response => {
      const { results, lastResult } = response;
      dispatch(getAcceptInvitationsSuccess(results));
      if (results.length < 10) {
        dispatch(changeLastResultForMatches(null));
      } else {
        dispatch(changeLastResultForMatches(lastResult));
      }
    })
    .catch(err => {
      dispatch(getAcceptInvitationsSuccess([]));
      dispatch(changeLastResultForMatches(null));
      console.log(err);
    });
};
/* ---------------------------------------------------
GET ACCEPT INVITATION SUCCESS
----------------------------------------------------- */
const getAcceptInvitationsSuccess = payload => ({
  type: matchesConstants.GET_ACCEPT_INVITATIONS,
  payload
});

/* ---------------------------------------------------
CLEAR ACCEPT INVITATION
----------------------------------------------------- */
export const clearAcceptInvitations = payload => ({
  type: matchesConstants.CLEAR_ACCEPT_INVITATIONS,
  payload
});

/* ---------------------------------------------------
  GET PEOPLE WHO LIKED ME
----------------------------------------------------- */

export const getPeopleWhoLikedMe = payload => dispatch => {
  matchesService
    .getPeopleWhoLikedMe()
    .then(response => {
      const { results, lastResult } = response;
      dispatch(getPeopleWhoLikedMeSuccess(results));
      if (results.length < 10) {
        dispatch(changeLastResultForMatches(null));
      } else {
        dispatch(changeLastResultForMatches(lastResult));
      }
    })
    .catch(err => {
      dispatch(getPeopleWhoLikedMeSuccess([]));
      dispatch(changeLastResultForMatches(null));
      console.log(err);
    });
};
/* ---------------------------------------------------
GET PEOPLE WHO LIKED ME
----------------------------------------------------- */
const getPeopleWhoLikedMeSuccess = payload => ({
  type: matchesConstants.GET_PEOPLE_WHO_LIKED_ME,
  payload
});

/* ---------------------------------------------------
CLEAR PEOPLE WHO LIKED ME
----------------------------------------------------- */
export const clearPeopleWhoLikedMe = payload => ({
  type: matchesConstants.CLEAR_PEOPLE_WHO_LIKED_ME,
  payload
});

/* ---------------------------------------------------
  GET PEOPLE EXPRESSED INTEREST IN ME
----------------------------------------------------- */

export const getPeopleExpressedInterestInMe = payload => dispatch => {
  matchesService
    .getPeopleExpressedInterestInMe()
    .then(response => {
      const { results, lastResult } = response;
      dispatch(getPeopleExpressedInterestInMeSuccess(results));
      if (results.length < 10) {
        dispatch(changeLastResultForMatches(null));
      } else {
        dispatch(changeLastResultForMatches(lastResult));
      }
    })
    .catch(err => {
      dispatch(changeLastResultForMatches(null));
      dispatch(getPeopleExpressedInterestInMeSuccess([]));
      console.log(err);
    });
};
/* ---------------------------------------------------
GET PEOPLE EXPRESSED INTEREST IN ME
----------------------------------------------------- */
const getPeopleExpressedInterestInMeSuccess = payload => ({
  type: matchesConstants.GET_PEOPLE_EXPRESSED_INTEREST_IN_ME,
  payload
});

/* ---------------------------------------------------
CLEAR PEOPLE EXPRESSED INTEREST IN ME
----------------------------------------------------- */
export const clearPeopleExpressedInterestInMe = payload => ({
  type: matchesConstants.CLEAR_PEOPLE_EXPRESSED_INTEREST_IN_ME,
  payload
});

/* ---------------------------------------------------
  GET CONNECTED MEMBERS
----------------------------------------------------- */

export const getConnectedMembers = payload => dispatch => {
  matchesService
    .getConnectedMembers()
    .then(response => {
      const { results, lastResult } = response;
      dispatch(getConnectedMembersSuccess(results));
      if (results.length < 10) {
        dispatch(changeLastResultForMatches(null));
      } else {
        dispatch(changeLastResultForMatches(lastResult));
      }
    })
    .catch(err => {
      dispatch(changeLastResultForMatches(null));
      dispatch(getConnectedMembersSuccess([]));
      console.log(err);
    });
};
/* ---------------------------------------------------
GET CONNECTED MEMBERS SUCCESS
----------------------------------------------------- */
const getConnectedMembersSuccess = payload => ({
  type: matchesConstants.GET_CONNECTED_MEMBERS,
  payload
});

/* ---------------------------------------------------
CLEAR CONNECTED MEMBERS
----------------------------------------------------- */
export const clearConnectedMembers = payload => ({
  type: matchesConstants.CLEAR_CONNECTED_MEMBERS,
  payload
});

/* ---------------------------------------------------
  CHANGE LAST RESULT FOR MATCHES
----------------------------------------------------- */
const changeLastResultForMatches = payload => ({
  type: matchesConstants.CHANGE_LAST_RESULT_FOR_MATCHES,
  payload
});
/* ---------------------------------------------------
 LOAD MORE SEARCH RESULTS
----------------------------------------------------- */

export const loadMoreSearchResults = payload => dispatch => {
  const { lastResult, type } = payload;

  matchesService
    .loadMoreResults(lastResult, type)
    .then(data => {
      const { results, lastResult, stateRef } = data;

      dispatch(loadMoreMatchResultsSuccess({ stateRef, results }));
      dispatch(changeLastResultForMatches(lastResult));
    })
    .catch(err => {
      dispatch(loadMoreMatchResultsSuccess([]));
      dispatch(changeLastResultForMatches(null));
    });
};
/* ---------------------------------------------------
  LOAD MORE MATCH RESULTS SUCCESS
----------------------------------------------------- */
const loadMoreMatchResultsSuccess = payload => ({
  type: matchesConstants.LOAD_MORE_MATCH_RESULTS,
  payload
});

/* ---------------------------------------------------
  MARK ALL PROFILE VISITORS AS READ
----------------------------------------------------- */

export const markAllProfileVisitorsAsRead = payload => dispatch => {
  matchesService
    .markProfileVisitorsRead()
    .then(response => {
      dispatch(markAllProfileVisitorsAsReadSuccess());
    })
    .catch(err => {
      //do nothing
    });
};
/* ---------------------------------------------------
MARK ALL PROFILE VISITORS AS READ SUCCESS
----------------------------------------------------- */
const markAllProfileVisitorsAsReadSuccess = payload => ({
  type: matchesConstants.MARK_ALL_PROFILE_VISITORS_AS_READ,
  payload
});

/* ---------------------------------------------------
  MARK ALL INVITATIONS RECEIVED AS READ
----------------------------------------------------- */

export const markAllInvitationsReceivedAsRead = payload => dispatch => {
  matchesService
    .markInvitationsReceivedRead()
    .then(response => {
      dispatch(markAllInvitationsReceivedAsReadSuccess());
    })
    .catch(err => {
      //do nothing
    });
};
/* ---------------------------------------------------
MARK ALL INVITATIONS RECEIVED AS READ SUCCESS
----------------------------------------------------- */
const markAllInvitationsReceivedAsReadSuccess = payload => ({
  type: matchesConstants.MARK_ALL_INVITATIONS_RECEIVED_AS_READ,
  payload
});

/* ---------------------------------------------------
  MARK ALL CONNECTED MEMBERS AS READ
----------------------------------------------------- */

export const markAllConnectedMembersAsRead = payload => dispatch => {
  matchesService
    .markConnectedMembersRead()
    .then(response => {
      dispatch(markAllConnectedMembersAsReadSuccess());
    })
    .catch(err => {
      //do nothing
    });
};
/* ---------------------------------------------------
MARK ALL CONNECTED MEMBERS AS READ SUCCESS
----------------------------------------------------- */
const markAllConnectedMembersAsReadSuccess = payload => ({
  type: matchesConstants.MARK_ALL_CONNECTED_MEMBERS_AS_READ,
  payload
});

/* ---------------------------------------------------
  MARK ALL EXPRESSED INTERESTS AS READ
----------------------------------------------------- */

export const markAllExpressedInterestsAsRead = payload => dispatch => {
  matchesService
    .markInterestsRead()
    .then(response => {
      dispatch(markAllExpressedInterestsAsReadSuccess());
    })
    .catch(err => {
      //do nothing
    });
};
/* ---------------------------------------------------
MARK ALL EXPRESSED INTERESTS AS READ SUCCESS
----------------------------------------------------- */
const markAllExpressedInterestsAsReadSuccess = payload => ({
  type: matchesConstants.MARK_ALL_EXPRESSED_INTERESTS_AS_READ,
  payload
});

/* ---------------------------------------------------
  MARK ALL LIKES AS READ
----------------------------------------------------- */

export const markAllLikesAsRead = payload => dispatch => {
  matchesService
    .markLikesRead()
    .then(response => {
      dispatch(markAllLikesAsReadSuccess());
    })
    .catch(err => {
      //do nothing
    });
};
/* ---------------------------------------------------
MARK ALL LIKES AS READ SUCCESS
----------------------------------------------------- */
const markAllLikesAsReadSuccess = payload => ({
  type: matchesConstants.MARK_ALL_LIKES_AS_READ,
  payload
});



// WEBPACK FOOTER //
// ./src/_actions/matchesActions.js